<template lang="pug">
   m-card(v-bind="$attrs" v-on="$listeners" class="effectiveness")

    template(#title="")
        div(class="d-flex justify-start")
            component(:is="iconComponent" @click.native="openIconInfoDialog" v-if="iconComponent")
            div(class="effectiveness--name")
              span(v-if="item.countObject") ({{item.countObject}}x)
              span &nbsp;{{ item.title }}
    template(#actions="")
        m-block-effectiveness-actions(:item="item" :assessment-id="assessmentId")
</template>
<script>

import MCard from '@modules/cards/m-card'
import MBlockEffectivenessActions from '@modules/blocks/actions/concrete/m-block-effectiveness-actions'

import effectiveness from "@mixins/helpers/_effectiveness";
import statusIconDialog from "@mixins/additional/_statusIconDialog";
export default {
    name: 'm-card-effectiveness',
    components: { MCard, MBlockEffectivenessActions },
    mixins:[effectiveness, statusIconDialog],
    props: {
        item: {
            type: Object,
            required: true
        },
        assessmentId: {
            type: String
        }
    },
    computed: {
        iconComponent(){
            return this.effectivenessHelper.answerIcon(this.item.answer)
        }
    }
}
</script>
<style lang="scss" scoped>
    .d-flex > * {
        flex: unset!important;
    }
    .effectiveness {
        &--name {
            margin-left: 10px;
            color: #000;
        }
        .icon-red {
            color: var(--v-error-base);
        }
        .icon-yellow {
            color: var(--v-warning-base);
        }
    }
</style>
